import {
  ClusterView,
  StatusCountStatusEnum,
  ViewClustersComponentsResponse,
} from '@cast/types-cluster-management';

export const generateClusterManagementClustersComponents = (
  mockClusters?: ClusterView[]
): ViewClustersComponentsResponse => {
  return {
    clusters: mockClusters ?? [
      {
        id: 'cluster-1-id',
        name: 'test1',
        cloudAccountId: 'test1',
        componentCount: 4,
        statuses: [
          {
            status: StatusCountStatusEnum.WARNING,
            count: 1,
          },
          {
            status: StatusCountStatusEnum.FAILED,
            count: 1,
          },
        ],
      },
      {
        id: 'cluster-2-id',
        name: 'test2',
        cloudAccountId: 'test2',
        componentCount: 0,
        statuses: [],
      },
      {
        id: 'cluster-3-id',
        name: 'test3',
        cloudAccountId: 'test3',
        componentCount: 1,
        statuses: [],
      },
      {
        id: 'cluster-4-id',
        name: 'test4',
        cloudAccountId: 'test4',
        componentCount: 0,
        statuses: [],
      },
    ],
    componentCount: 13,
  };
};
